<template>
  <el-dialog :close-on-click-modal="false"  
    title="变种设定"
    :visible.sync="visible"
    width="50%"
    center
    @close="handleClose"
    class="amazon_category_dialog"
    
  >
    <div>
      <el-table
        v-for="(record, index) in tables"
        :key="index"
        :data="record.skuList"
        :span-method="objectSpanMethod"
        :header-cell-style="{ 'text-align': 'center' }"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="id" label="产品信息" width="180">
          <template slot-scope="scope">
            <div style="overflow:hidden;">
              <div class="avator">
                <img :src="scope.row.picUrl" />
              </div>
              <div class="info">
                <div>{{ scope.row.designProName }}</div>
                <div>{{ scope.row.designEngProName }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="颜色">
          <template slot-scope="scope">
            <div style="overflow:hidden;">
              <el-checkbox v-model="scope.row.checked">{{
                scope.row.color
              }}</el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="amount1" label="尺码">
          <template slot-scope="scope">
            <div style="overflow:hidden;">
              {{ scope.row.size }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="amount2" label="价格">
          <template slot-scope="scope">
            <div style="overflow:hidden;">
              <el-input
                v-model="scope.row.price"
                placeholder="请输入内容"
                size="mini"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="amount3" label="库存">
          <template slot-scope="scope">
            <div style="overflow:hidden;">
              <el-input
                v-model="scope.row.quantity"
                placeholder="请输入内容"
                size="mini"
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit" size="small"
        >确 定</el-button
      >
      <el-button @click="handleClose" size="small">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getSkuList } from "@/api/template/template"

export default {
  name: "PriceConfigDialog",
  data() {
    return {
      tables: [],
      tableData: [
        {
          id: "12987122",
          name: "王小虎",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
        },
        {
          id: "12987123",
          name: "王小虎",
          amount1: "165",
          amount2: "4.43",
          amount3: 12,
        },
        {
          id: "12987124",
          name: "王小虎",
          amount1: "324",
          amount2: "1.9",
          amount3: 9,
        },
        {
          id: "12987125",
          name: "王小虎",
          amount1: "621",
          amount2: "2.2",
          amount3: 17,
        },
        {
          id: "12987126",
          name: "王小虎",
          amount1: "539",
          amount2: "4.1",
          amount3: 15,
        },
      ],
    }
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  mounted() {
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    designId: {
      type: String,
      default: '',
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(){
        if(this.visible){
          this.getSkuList()
        }
      }
    }
  },
  methods: {
    handleSubmit() {
      let skuList = []
      for (let record of this.tables) {
        for (let item of record.skuList) {
          if (item.checked) {
            skuList.push({
              dzSkuId: item.dzSkuId,
              quantity: item.quantity,
              price: item.price,
              size: item.size,
              color: item.color,
              designId: item.designId,
            })
          }
        }
      }
      this.$emit("change", false)
      this.$emit("update", skuList)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % row.count === 0) {
          return {
            rowspan: row.count,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    async getSkuList() {
      let designId = this.$route.query.designId
      if(!designId){
        designId = this.designId
      }
      let result = await getSkuList({ designId })
      for (let record of result.rows) {
        for (let item of record.skuList) {
          item.designEngProName = record.designEngProName
          item.designId = record.designId
          item.designProName = record.designProName
          item.picUrl = record.picUrl
          item.count = record.skuList.length
          item.price = ""
          item.quantity = ""
          item.checked = true
        }
      }

      this.tables = result.rows
    },
    handleClose() {
      this.$emit("change", false)
    },
  },
}
</script>

<style scoped>
.avator img {
  width: 100px;
}
.avator {
  float: left;
}
.info {
  float: left;
  margin-left: 4px;
}
</style>
